module.exports = __webpack_public_path__ + "img/admin.b0c63b72.svg";